import { render, staticRenderFns } from "./ExpenseItem.vue?vue&type=template&id=5ab56746&"
import script from "./ExpenseItem.vue?vue&type=script&lang=js&"
export * from "./ExpenseItem.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseItem.vue?vue&type=style&index=0&id=5ab56746&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports